import { useParams } from 'react-router-dom';
import * as urlUtil from 'js/utils/url.util';

export const useGetPageRoutingURL = (href) => {
    const { pathLang } = useParams();

    if (!href) {
        return '';
    }

    if (urlUtil.isExternalUrl(href) || urlUtil.isHashLink(href)) {
        return href;
    }

    const pathWithParams = urlUtil.getPathWithParams(href);
    const { cleanUrl, lang } = urlUtil.parseUrl(pathWithParams);

    const selectedPathLang = pathLang ? `/${pathLang}` : '';

    return lang ? href : `${selectedPathLang}${cleanUrl}`;
};
